import { regions } from '@scoir/states'
import { get } from 'lodash'

export const FOUR_YEAR_US_OLD = 'FOUR_YEAR_US_OLD'
export const TWO_YEAR_US_OLD = 'TWO_YEAR_US_OLD'
export const FOUR_YEAR_US = 'FOUR_YEAR_US'
export const TWO_YEAR_US = 'TWO_YEAR_US'
export const CAREER_AND_TRADE = 'CAREER_AND_TRADE'
export const INTERNATIONAL = 'INTERNATIONAL'
export const BLANK_SEARCH = 'BLANK_SEARCH'
export const SCOIR_APPLY = 'APPLY_WITH_SCOIR'
export const COALITION_MEMBER = 'COALITION_MEMBER'
export const SCOIR_APPLY_TRANSFER = 'APPLY_WITH_SCOIR_TRANSFER'
export const NORTHEAST = 'NORTHEAST'
export const SOUTH = 'SOUTH'
export const WEST = 'WEST'
export const MIDWEST = 'MIDWEST'
export const TEST_OPTIONAL = 'TEST_OPTIONAL'

const getStates = (regionName) => {
  const region = regions.find((region) => {
    return region.name === regionName
  })
  const states = get(region, 'states', [])
  return states.map((state) => {
    return state.value
  })
}

export const PREDEFINED_SEARCHES = {
  [BLANK_SEARCH]: {},
  [FOUR_YEAR_US_OLD]: {
    LocationCategory: ['Domestic'],
    Degrees: ['Bachelors'],
  },
  [TWO_YEAR_US_OLD]: {
    LocationCategory: ['Domestic'],
    Degrees: ['Associates'],
  },
  [FOUR_YEAR_US]: {
    LocationCategory: ['Domestic'],
    UnivType: ['4 year'],
  },
  [TWO_YEAR_US]: {
    LocationCategory: ['Domestic'],
    UnivType: ['2 year'],
  },
  [CAREER_AND_TRADE]: {
    LocationCategory: ['Domestic'],
    SchoolClassifier: ['CareerAndTrade'],
  },
  [INTERNATIONAL]: {
    LocationCategory: ['International'],
  },
  [SCOIR_APPLY]: {
    ScoirApplyApplicantTypes: ['first'],
  },
  [SCOIR_APPLY_TRANSFER]: {
    ScoirApplyApplicantTypes: ['transfer'],
  },
  [COALITION_MEMBER]: {
    CoalitionMember: ['T'],
  },
  [NORTHEAST]: {
    State: getStates('Northeast'),
  },
  [SOUTH]: {
    State: getStates('South'),
  },
  [WEST]: {
    State: getStates('West'),
  },
  [MIDWEST]: {
    State: getStates('Midwest'),
  },
  [TEST_OPTIONAL]: {
    TestOptional: ['T'],
  },
}
